var version = {
    "name":      "dativery",
    "buildDateCode": "20260128-145400",
    "buildDate": "Wed Jan 28 2026 14:54:00 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260128-145400",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;